import React from 'react';
import { GuidedTour } from './GuidedTour';
import { NannyGuidedTour } from './NannyGuidedTour';
import { useTour } from '@/contexts/TourContext';
import { useAuth } from '@/hooks/useAuth';
import { isNannyUser, isContractorUser, isClientUser } from '@/types/user';

export const TourWrapper: React.FC = () => {
  const { isTourAvailable, tourStatus } = useTour();
  const { user } = useAuth();

  // Only show the tour or button if the tour is available 
  // (demo account or new account)
  if (!isTourAvailable) {
    return null;
  }

  // Don't show tours for contractors or clients
  if (user && (isContractorUser(user) || isClientUser(user))) {
    return null;
  }

  // Tour button is now in the MenuBar, so we don't show it here anymore
  if (tourStatus === 'completed') {
    return null;
  }

  // Render the appropriate tour based on user type
  if (user && isNannyUser(user)) {
    return <NannyGuidedTour />;
  }

  // Only show employer tour for employers (not contractors or clients)
  if (user && !isContractorUser(user) && !isClientUser(user)) {
    return <GuidedTour />;
  }

  // Default: no tour for unsupported user types
  return null;
}; 